(function () {
  angular.module("akitabox.workOrder.detail", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.issueType",
    "akitabox.core.services.flag",
    "akitabox.core.services.maintenanceType",
    "akitabox.core.services.organization",
    "akitabox.core.services.recentActivity",
    "akitabox.core.services.schedule",
    "akitabox.core.services.timeZone",
    "akitabox.core.services.trade",
    "akitabox.core.services.type",
    "akitabox.core.services.user",
    "akitabox.core.toast",
    "akitabox.core.lib.moment",
    "akitabox.ui.dialogs.workOrderLog.createUpdate",
    "akitabox.ui.dialogs.workOrder.complete",
    "akitabox.ui.dialogs.workOrder.cancel",
    "akitabox.ui.dialogs.workOrder.reopen",
    "akitabox.ui.dialogs.workOrder.delete",
    "akitabox.ui.dialogs.message.create",
    "akitabox.ui.dialogs.displayText",
    "akitabox.ui.components.multipleAssigneeInput",
    "akitabox.ui.components.radioButtonGroup",
  ]);
})();
